import { Colors, Text } from 'library';
import React from 'react';
import { Grid } from '@material-ui/core';
import { track } from 'shared';
import ReplayIcon from '@material-ui/icons/Replay';

type Message = {
    body: string;
    status: 'awaiting' | 'failed' | 'sent';
};

interface IProps {
    messages: Message[];
    signUp: (s: string) => void;
}

export default function Messages({ messages, signUp }: IProps) {
    function retryFailed() {
        track('External Public Profile: Public Messaging retry button clicked');
        signUp('Public Profile: Public Messaging retry');
    }

    function handleCaption(status: string) {
        switch (status) {
            case 'awaiting':
                return (
                    <Text variant="deprecatedCaption" textStyle={{ paddingTop: 0 }}>
                        Awaiting contact info...
                    </Text>
                );
            case 'failed':
                return (
                    <Text
                        variant="deprecatedCaption"
                        textStyle={{ paddingTop: 0, color: Colors.mediumRed, cursor: 'pointer' }}
                        onClick={retryFailed}
                    >
                        <ReplayIcon fontSize="small" />
                        Failed. Click to resend
                    </Text>
                );
            case 'sent':
                return (
                    <Text variant="deprecatedCaption" textStyle={{ paddingTop: 0, color: Colors.turquoise }}>
                        Sent
                    </Text>
                );
        }
    }

    const Message = ({ message }: { message: Message }) => {
        return (
            <Grid item container direction="column" alignItems="flex-end" style={{ marginBottom: 15 }}>
                <Grid
                    item
                    style={{
                        padding: 10,
                        backgroundColor: Colors.lightGrey,
                        borderRadius: 15,
                        maxWidth: 200,
                    }}
                >
                    <Grid item style={{ overflowWrap: 'anywhere' }}>
                        <Text variant="body2">{message.body}</Text>
                    </Grid>
                </Grid>
                <Grid container item justify="flex-end">
                    {handleCaption(message.status)}
                </Grid>
            </Grid>
        );
    };

    return (
        <Grid
            container
            direction="column-reverse"
            style={{
                flexGrow: 1,
                paddingRight: 15,
                paddingLeft: 15,
                paddingBottom: 30,
                overflow: 'scroll',
                flexWrap: 'nowrap',
            }}
        >
            {messages.map((message, index) => {
                return <Message key={index} message={message} />;
            })}
        </Grid>
    );
}
